(function () {
  var el = document.getElementById('atomberg-stt');
  if (!(el instanceof HTMLButtonElement)) return;

  var btn = el;
  var thresholdDesktop = parseInt(btn.dataset.sttThreshold || '400', 10) || 400;
  var thresholdMobile = parseInt(btn.dataset.sttThresholdMobile || '300', 10) || 300;

  function getThreshold() {
    return window.innerWidth <= 749 ? thresholdMobile : thresholdDesktop;
  }

  function onScroll() {
    var past = window.scrollY > getThreshold();
    if (past) {
      btn.removeAttribute('hidden');
      btn.classList.add('atomberg-stt--visible');
    } else {
      btn.classList.remove('atomberg-stt--visible');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  btn.addEventListener('click', function () {
    // Remove immediately on click — on iOS Safari, scroll events do not fire
    // during smooth scroll so onScroll would not remove --visible otherwise.
    btn.classList.remove('atomberg-stt--visible');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
